/**
 * Supabase implementation of RealtimeAdapter.
 * Uses supabase.channel() + postgres_changes under the hood.
 */

import { createClient } from '@/lib/supabase/client';
import type { RealtimeAdapter, RealtimeEvent, RealtimePayload, RealtimeSubscription } from '../interfaces';

export class SupabaseRealtimeAdapter implements RealtimeAdapter {
  subscribe<T = Record<string, unknown>>(
    channel: string,
    table: string,
    event: RealtimeEvent,
    callback: (payload: RealtimePayload<T>) => void
  ): RealtimeSubscription {
    const supabase = createClient();
    const ch = supabase
      .channel(channel)
      .on(
        'postgres_changes' as any,
        { event: event === '*' ? '*' : event, schema: 'public', table },
        (raw: any) => {
          callback({
            eventType: raw.eventType ?? event,
            table: raw.table ?? table,
            schema: raw.schema ?? 'public',
            new: raw.new ?? null,
            old: raw.old ?? null,
          });
        }
      )
      .subscribe();

    return {
      unsubscribe: () => {
        supabase.removeChannel(ch);
      },
    };
  }

  async broadcast(channel: string, event: string, payload: Record<string, unknown>): Promise<void> {
    const supabase = createClient();
    await supabase.channel(channel).send({
      type: 'broadcast',
      event,
      payload,
    });
  }
}
